import React from "react";
import { Box, Grid2 } from "@mui/material";
import Img1 from "../../assets/images/dashboard/img1.jpg";
import Welcome from "../../assets/images/dashboard/page1/Welcome.png";
import Star from "../../assets/images/dashboard/page1/star.png";
import Puppylove from "../../assets/images/dashboard/page1/puppylove.png";
import Grooming from "../../assets/images/dashboard/page1/grooming.png";
import Readmore from "../../assets/images/dashboard/page1/readmore.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Page1 = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${Img1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid2
        container
        alignItems={"center"}
        spacing={"10px"}
        sx={{ width: "90%" }}
      >
        {/* {isTablet && (
          <Grid2 size={12}>
            <Box sx={{ padding: "0 30px" }}>
              <img
                style={{
                  height: "auto",
                  width: "100%",
                }}
                src={Welcome}
                alt="Welcome"
              />
            </Box>
          </Grid2>
        )} */}
        <Grid2
          size={{ xs: 12, md: 6 }}
          sx={{ paddingLeft: "20px", marginTop: { xs: "180px", lg: 0 } }}
        >
          <Box
            sx={{
              display: "flex ",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <img
              style={{
                height: "auto",
                width: "10%",
              }}
              src={Star}
              alt="Star"
            />
            <img
              style={{
                height: "auto",
                width: "15%",
              }}
              src={Puppylove}
              alt="Puppylove"
            />
          </Box>
          <Box>
            <img
              style={{
                height: "auto",
                width: "100%",
              }}
              src={Grooming}
              alt="Grooming"
            />
          </Box>

          <Box
            onClick={() => navigate("../../services")}
            sx={{ cursor: "pointer", marginTop: "30px" }}
          >
            <img
              style={{
                height: "auto",
                width: isTablet ? "50%" : "25%",
              }}
              src={Readmore}
              alt="Readmore"
            />
          </Box>
        </Grid2>
        {!isTablet && <Grid2 size={2} />}{" "}
        {!isTablet && (
          <Grid2 size={4}>
            <Box sx={{ marginTop: "150px" }}>
              <img
                style={{
                  height: "auto",
                  width: "75%",
                }}
                src={Welcome}
                alt="Welcome"
              />
            </Box>
          </Grid2>
        )}
      </Grid2>
    </Box>
  );
};

export default Page1;
